import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b819c3a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title" }
const _hoisted_2 = { class: "selected-settings" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_message_sharing_pop_up = _resolveComponent("message-sharing-pop-up")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["access-area", {'show-access-body': _ctx.showSettings}])
  }, [
    _createElementVNode("div", {
      class: "access-header",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showSettings = !_ctx.showSettings))
    }, [
      _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.$localize('messaging.settings.title')), 1),
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.allowedResharedValue) + ", " + _toDisplayString(_ctx.allowedSavingValue), 1)
    ]),
    (_ctx.showSettings)
      ? (_openBlock(), _createBlock(_component_message_sharing_pop_up, {
          key: 0,
          "share-settings": _ctx.shareSettings,
          onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showSettings = false)),
          onUpdateSettings: _ctx.updateSettings
        }, null, 8, ["share-settings", "onUpdateSettings"]))
      : _createCommentVNode("", true)
  ], 2))
}